import { Link } from 'react-router-dom';
import { comics } from '@/mocks/data';

interface ContinueReadingProps {
  currentId: number;
}

export default function ContinueReading({ currentId }: ContinueReadingProps) {
  const otherComics = comics.filter((c) => c.id !== currentId).slice(0, 4);

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            继续探索更多<strong className="text-primary-500">漫画</strong>
          </h2>
          <p className="text-sm text-foreground-500">发现更多精彩韩漫作品</p>
        </div>

        <div className="flex justify-center gap-4 md:gap-6 flex-wrap" data-product-shop="">
          {otherComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group block cursor-pointer"
            >
              <div className="w-[150px] md:w-[180px] aspect-[2/3] rounded-lg overflow-hidden mb-3">
                <img
                  src={comic.imageUrl}
                  alt={comic.title}
                  title={`${comic.title} - 韩漫屋免费韩漫`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <h3 className="text-sm font-medium text-foreground-950 truncate w-[150px] md:w-[180px] group-hover:text-primary-500 transition-colors">
                {comic.title}
              </h3>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}